import { IApiProviderAddon } from "../../../../interfaces/api/group/results/components/IApiProviderAddon";
import { IProviderAddon } from "../../../../interfaces/IProviderAddon";

function remoteAddOnsToLocal(addOnList: IApiProviderAddon[]): IProviderAddon[] {
    if (!addOnList) return [];

    return addOnList.map((addon) => {
        return {
            id: addon.providerAddOnId,
            systemName: addon.systemName,
            providerId: addon.providerId,
            addOnName: addon.addOnName,
            fee: addon.fee,
            discountPercentage: addon.discountPercentage,
            isSelectedByDefault: addon.isSelectedByDefault,
            quoteAmountInfoText: addon.quoteAmountInfoText,
            tipText: addon.tipText,
            breakdownList: addon.breakdownList
        };
    });
}

function localAddOnToRemote(addOnList: IProviderAddon[]): IApiProviderAddon[] {
    if (!addOnList) return [];

    return addOnList.map((addon) => {
        return {
            providerAddOnId: addon.id,
            systemName: addon.systemName,
            providerId: addon.providerId,
            addOnName: addon.addOnName,
            fee: addon.fee,
            discountPercentage: addon.discountPercentage,
            isSelectedByDefault: addon.isSelectedByDefault,
            quoteAmountInfoText: addon.quoteAmountInfoText,
            tipText: addon.tipText,
            breakdownList: addon.breakdownList
        };
    });
}

export default {
    remoteToLocal: remoteAddOnsToLocal,
    localToRemote: localAddOnToRemote
};
